import { ProdutoModel } from "./produto.model"
import { UsuarioModel } from "./usuario.model";

export class VendasDetalheModel {
  constructor(init?: Partial<VendasDetalheModel>) {
    Object.assign(this, init);
  }

  codigo: number;
  codigoProduto: number;
  produto: ProdutoModel;
  custo: number;
  desconto: number;
  acrescimo: number;
  venda: number;
  unMedCom: string;
  qtd: number;
  qtdCom: number;
  qtdDevolvida: number;
  totalItem: number;
  obs: string;
  codigoStatus: number;
  materiaPrima: VendasDetalheModel[];
  tipoSaida: string;

  vendedor: UsuarioModel;

  codigoFamilia: number;

  dataHoraPedido: Date;
  agora: Date;

  // Usado unicamente para a tela de tranferência de itens.
  checked: boolean;

  /**
    * @returns this.produto.valorVenda || this.venda  * this.qtd
  */
  obterTotalItem() {
    return (this.produto.valorVenda || this.venda) * this.qtd;
  }
}
